import "./AboutUs.css";
import Office from "../../assets/img/unity_about_us.png";
import FallbackImg from "../../components/FallbackImg";

const AboutUs = () => {
  return (
    <div className="aboutus">
      <FallbackImg src={Office} alt="office" />
      <div className="dark-overlay"></div>
      <div className="aboutus-margin">
        <div className="aboutus-title">
          OUR STORY
          <br />
          <strong>About Us.</strong>
        </div>
        <div className="aboutus-description">
          Unity Momentum Sdn Bhd, established in 2022, is a rapidly growing B2B
          e-commerce
          <br />
          platform specializing in electrical appliances. Backed by 26 years of
          industry
          <br />
          experience, we combine deep market knowledge with modern digital
          solutions to
          <br />
          serve the needs of SMEs across Malaysia. Today, our platform proudly
          supports over
          <br />
          1,000 active users, reflecting our commitment to delivering value and
          reliability
          <br />
          in every transaction.
          <br />
          <br />
          Vision
          <br />
          To become the No. 1 B2B e-commerce platform for electrical appliances
          in Malaysia.
          <br />
          <br />
          Mission
          <br />
          Empowering SMEs with competitive pricing, reliable supply, and digital
          convenience to
          <br />
          help them grow and thrive.
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
